import React from 'react';

const ApiContext = React.createContext({
    baseUrl: ''
});

export default ApiContext;
